export enum FormModeEnum {
  CREATE,
  EDIT,
  VIEW,
  ASSIGN,
  REMOVE,
}
